import { t } from 'i18next';
import * as yup from 'yup';

export const saveElementAsTemplateSchema = () =>
  yup.object().shape({
    customIdentifier: yup.string().label(t('labelCustomIdentifier')).nullable().required(),
    description: yup.string().label(t('labelDescription')).nullable().required(),
  });
